import { AsyncPipe, NgClass } from '@angular/common';
import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormModel, DynamicFormService, DynamicInputModel } from '@ng-dynamic-forms/core';
import { LanguageService, TranslatePipe, TranslationService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CheckoutFormService } from 'src/app/core/checkout/facade/checkout-form.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { DynamicFormsComponent } from '../../dynamic-forms/dynamic-forms.component';
@Component({
  selector: 'app-checkout-order-review',
  templateUrl: './checkout-order-review.component.html',
  styleUrls: ['./checkout-order-review.component.scss'],
  providers: [CheckoutFormService, AsyncPipe],
  imports: [NgClass, DynamicFormsComponent, AsyncPipe, TranslatePipe],
})
export class CheckoutOrderReviewComponent implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {
  formGroup: FormGroup;
  formModel: DynamicFormModel;
  placeOrderSubscription$: Subscription;
  checkoutReviewFormModelSubscription$: Subscription;
  checkoutReviewFormGroupSubscription$: Subscription;
  forwardOrderTranslatedValueSubscription$: Subscription;
  orderTypeSubscription$: Subscription;
  poNumberInput: DynamicInputModel;
  poNumberInputSnah: DynamicInputModel;
  businessType: string = this.currentBusinesstype.getBusinessType();

  constructor(
    protected checkoutFormService: CheckoutFormService,
    private formService: DynamicFormService,
    private componentService: ComponentService,
    private cdr: ChangeDetectorRef,
    protected checkoutServiceExtends: CheckoutServiceExtends,
    private languageService: LanguageService,
    private translation: TranslationService,
    private pipeAsync: AsyncPipe,
    private currentBusinesstype: CurrentBusinessType
  ) {}

  ngOnInit() {
    this.placeOrderSubscription$ = this.checkoutServiceExtends.placeOrder$.subscribe((status) => {
      if (status) {
        if (this.formGroup.get('poNumber') !== null) {
          this.formGroup.get('poNumber').disable({ onlySelf: true });
        }
        if (this.formGroup.get('poNumberSnah') !== null) {
          this.formGroup.get('poNumberSnah').disable({ onlySelf: true });
        }
        if (this.formGroup.get('poNumberOptional') !== null) {
          this.formGroup.get('poNumberOptional').disable({ onlySelf: true });
        }
        if (this.formGroup.get('fullOrderBasedOnAvailability') !== null) {
          this.formGroup.get('fullOrderBasedOnAvailability').disable({ onlySelf: true });
        }
        if (this.formGroup.get('emailAddresses') !== null) {
          this.formGroup.get('emailAddresses').disable({ onlySelf: true });
        }
      }
    });

    this.checkoutReviewFormModelSubscription$ = this.componentService.dynamicFormModel$.subscribe(
      (checkoutReviewFormModel) => {
        this.updateFormModel(checkoutReviewFormModel);
      }
    );

    this.checkoutReviewFormGroupSubscription$ = this.componentService.dynamicFormGroup$.subscribe(
      (checkoutReviewFormGroup) => {
        this.updateFormGroup(checkoutReviewFormGroup);
      }
    );

    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  validateAllFieldsOnInitialization(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      const formField = this.formService.findModelById<any>(field, this.formModel);
      if (formField !== null) {
        if (formField.required && (control.value === null || control.value === '') && formField.pattern) {
          this.formGroup.setErrors({ val: true });
        }
      }
    });
  }

  updateFormGroup(form: any): void {
    this.formGroup = form;
    this.validateAllFieldsOnInitialization(this.formGroup);
    this.checkoutServiceExtends.setCheckoutFormsError('CHECKOUT_ORDER_REVIEW', !this.formGroup.valid);
    this.checkoutFormService.updateCheckoutForm(form.value);
    this.orderTypeSubscription$ = this.checkoutServiceExtends.orderType$.subscribe((orderType) => {
      const poNumberSnahControl = this.formGroup.get('poNumberSnah');
      if (poNumberSnahControl) {
        let forwardOrder: string;
        this.forwardOrderTranslatedValueSubscription$ = this.translation
          .translate(`cart.poNumberSnahPlannedOrder`)
          .subscribe((data) => (forwardOrder = data));

        if (orderType === 'PO' && this.businessType == 'fish') {
          poNumberSnahControl.setValue(forwardOrder);
        } else if (orderType === 'SO' && poNumberSnahControl.value === forwardOrder) {
          poNumberSnahControl.reset();
        }
        this.checkoutFormService.updateCheckoutForm(form.value);
        poNumberSnahControl.value === forwardOrder ? poNumberSnahControl.disable() : poNumberSnahControl.enable();
      }
    });
  }

  updateFormModel(form: any): void {
    this.formModel = form;

    this.poNumberInput = this.formService.findModelById<DynamicInputModel>('poNumber', this.formModel);
    if (this.poNumberInput !== null) {
      this.poNumberInput.maxLength = 15;
      this.formService.detectChanges();
    }

    this.poNumberInputSnah = this.formService.findModelById<DynamicInputModel>('poNumberSnah', this.formModel);
    if (this.poNumberInputSnah !== null) {
      const hasError = {
        pattern: this.pipeAsync.transform(this.getTranslatedError('poNumberSnah')),
      };
      this.poNumberInputSnah.errorMessages = hasError;
      this.formService.detectChanges();
    }
  }

  getTranslatedError(id: string): Observable<string> {
    return this.translation.translate(`error.dynamicform.${id}`);
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngAfterViewInit() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngAfterContentChecked() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    this.placeOrderSubscription$?.unsubscribe();
    this.checkoutReviewFormModelSubscription$?.unsubscribe();
    this.checkoutReviewFormGroupSubscription$?.unsubscribe();
    this.orderTypeSubscription$?.unsubscribe();
  }
}
